module.exports = __webpack_public_path__ + "img/login-img.ad0097ba.png";